
document.addEventListener("DOMContentLoaded", async() => {
    const popupEl = document.querySelector(".popup-detail");
    if (popupEl) {
        const { openPopup } = await import("../components/modal.js");
        openPopup();
    }
    const swiperRecommendEls = document.querySelectorAll(".js-swiper-recommend");

    if (swiperRecommendEls.length > 0) {
        const { renderSwiperRecommend } = await import(
            "../components/swiper.js"
        );
        const { PaginationProgress } = await import(
            "../components/pagination-progress.js"
        );

        swiperRecommendEls.forEach((el) => {
            const swiper = renderSwiperRecommend(el);
            if (!swiper) return;

            const pagination = new PaginationProgress(swiper.pagination.el);
            const DURATION = 5000;
            const INTERVAL = 500;
            let timer = null;
            let elapsed = 0;
            let isVisible = false;

            const startProgress = () => {
                if (!isVisible) return;
                pagination.resetAll();
                const activeIndex = swiper.realIndex;
                elapsed = 0;
                clearInterval(timer);

                timer = setInterval(() => {
                    if (!isVisible) return;
                    elapsed += INTERVAL;
                    const percent = Math.min((elapsed / DURATION) * 100, 100);
                    pagination.setProgress(activeIndex, percent);

                    if (percent >= 100) {
                        clearInterval(timer);
                        setTimeout(() => swiper.slideNext(), 300);
                    }
                }, INTERVAL);
            };

            const stopProgress = () => {
                clearInterval(timer);
                timer = null;
            };

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            isVisible = true;
                            startProgress();
                        } else {
                            isVisible = false;
                            stopProgress();
                        }
                    });
                },
                {
                    threshold: 0.3,
                }
            );

            observer.observe(el);

            swiper.on("slideChange", () => {
                clearInterval(timer);
                startProgress();
            });

            window.addEventListener(
                "resize",
                () => {
                    pagination.refresh();
                    clearInterval(timer);
                    startProgress();
                },
                { passive: true }
            );
        });
    }
    const { renderTabs } = await import ("../components/tab.js");
    renderTabs(".js-tab");

    const swiperEntaEls = document.getElementById("js-swiper-enta");
    if (swiperEntaEls) {
        const { renderSwiperEnta } = await import("../components/swiper.js");
        renderSwiperEnta(swiperEntaEls);
    }
    const anchorEl = document.querySelectorAll(".handle-anchor");
    if (anchorEl) {
        const { initAnchorLink } = await import("../components/anchorlink.js");
        initAnchorLink();
    }
});
